/* eslint-disable @typescript-eslint/no-restricted-imports */
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../types';

type DispatchFunc = () => AppDispatch;
const useStoreDispatch: DispatchFunc = useDispatch;

export default useStoreDispatch;
